import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const masterLayoutState = {
  walletInfo: null,
  contactList: null,
  promotionReviewInfo: null,
  error: null,
  listLoading: false,
  actionsLoading: false,
  searchLoading: false,
  isRefresh: false,
};

export const masterLayoutSlice = createSlice({
  name: "masterLayout",
  initialState: masterLayoutState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    walletInfoFetched: (state, action) => {
      state.listLoading = false;
      state.walletInfo = action.payload.data ?? {};
    },
    promotionReviewInfoFetched: (state, action) => {
      state.listLoading = false;
      state.promotionReviewInfo = action.payload.data ?? {};
    },
    contactListFetched: (state, action) => {
      state.contactList = action.payload.data ?? {};
    },
  },
});
